module.exports = __webpack_public_path__ + "static/media/ecusson.24cd8dca.png";